import { Action } from '@ngrx/store';
import { DeclIrSefParamsDTO } from './../dominios/DTO/declIrSef-árams.DTO';

// Section 2
export const ADD_PARAM       = '[PARAM] Add'
export const CLEAR_PARAM    = '[PARAM] Clear'

// Section 3
export class AddParam implements Action {
    readonly type = ADD_PARAM

    constructor(public payload: DeclIrSefParamsDTO) {}
}

export class ClearParam implements Action {
    readonly type = CLEAR_PARAM

    constructor(public payload: number) {}
}

// Section 4
export type Actions = AddParam | ClearParam



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/actions/param.action.ts